export const Forums = [
  {
    path: '/forums/:app_module_id',
    name: 'forums.index',
    component: () => import('@/pages/Forums/ForumsModule')
  },
  {
    path: '/forums/:app_module_id/:discussion_name/:discussion_id',
    name: 'forums.discussion',
    component: () => import('@/pages/Forums/ForumsDiscussions')
  },
  {
    path: '/forums/:app_module_id/:discussion_name/:discussion_id/item/:item_id',
    name: 'forums.item',
    component: () => import('@/pages/Forums/ForumsPage')
  },
  {
    path: '/forums/:app_module_id/:discussion_name/:discussion_id/item/:item_id/edit',
    name: 'forums.edit',
    component: () => import('@/pages/Forums/ForumsEdit')
  }
]
